// @components
import { Collapse } from 'antd';
import { useContext } from 'react';
import Context from 'context/appContext';

//@utils
import { formatPrice } from 'utils/utils';

// collapsable de las coberturas por planes
export default function CollapseComponent() {
    const { sidebarData } = useContext(Context);

    return (
        <Collapse className='ant-collapse-generic' defaultActiveKey={['0']}>
            {sidebarData && sidebarData.map((data) =>
                <><h2>{data.title ? data.title : ''}</h2>
                    {data && data.items.map((item, index) =>
                        <Collapse.Panel header={<div className='ant-collapse-header-description'>
                            <span>{item.title ? item.title : ''}</span>
                            <p>{item.price ? formatPrice(item.price) : ''}</p></div>} key={index}>
                            <ul className='list-plans'>
                                {item && item.values.map((value) => <>
                                    <li>
                                        <strong>{value.title ? value.title : ''}</strong>
                                    </li>
                                    {value.rows.map(row =>
                                        row.label && row.value && (<li>
                                            <p>{row.label}</p>
                                            <p>{row.value}</p>
                                        </li>))}
                                </>)}
                            </ul>
                        </Collapse.Panel>)}</>
            )}
        </Collapse>
    )
}